import { forwardRef, type ComponentPropsWithRef } from "react";
import { type CoreButton } from "@boi/components-core";

import * as S from "./ButtonBase.styled";

export type ButtonBaseProps = Omit<
  ComponentPropsWithRef<"button">,
  "style" | "className"
> & {
  variant: CoreButton.Variant;
  testID: string;
  isLoading?: boolean;
  fullWidth?: boolean;
};

const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (props, ref) => {
    const {
      variant,
      children,
      testID,
      type,
      isLoading,
      fullWidth,
      ...buttonProps
    } = props;

    return (
      <S.ButtonBase
        {...buttonProps}
        ref={ref}
        $variant={variant}
        $isLoading={isLoading}
        $fullWidth={fullWidth}
        data-testid={testID}
        type={type || "button"}
      >
        <S.BottomLayer $variant={variant} $isLoading={isLoading} />
        <S.TopLayer $variant={variant} $isLoading={isLoading}>
          {children}
        </S.TopLayer>
      </S.ButtonBase>
    );
  }
);

ButtonBase.displayName = "ButtonBase";

export default ButtonBase;
